import api from './api';

export const masterService = {
  // 1. Departments
  getDepartments: async (params = {}) => {
    const response = await api.get('/departments', { params });
    return response.data;
  },
  getDepartmentById: async (id) => {
    const response = await api.get(`/departments/${id}`);
    return response.data;
  },
  createDepartment: async (data) => {
    const response = await api.post('/departments', data);
    return response.data;
  },
  updateDepartment: async (id, data) => {
    const response = await api.put(`/departments/${id}`, data);
    return response.data;
  },
  updateDepartmentStatus: async (id, isActive) => {
    const response = await api.patch(`/departments/${id}/status`, { isActive });
    return response.data;
  },

  // 2. Sample Types
  getSampleTypes: async (params = {}) => {
    const response = await api.get('/sample-types', { params });
    return response.data;
  },
  getSampleTypeById: async (id) => {
    const response = await api.get(`/sample-types/${id}`);
    return response.data;
  },
  createSampleType: async (data) => {
    const response = await api.post('/sample-types', data);
    return response.data;
  },
  updateSampleType: async (id, data) => {
    const response = await api.put(`/sample-types/${id}`, data);
    return response.data;
  },
  updateSampleTypeStatus: async (id, isActive) => {
    const response = await api.patch(`/sample-types/${id}/status`, { isActive });
    return response.data;
  },

  // 3. Sample Containers
  getSampleContainers: async (params = {}) => {
    const response = await api.get('/sample-containers', { params });
    return response.data;
  },
  getSampleContainerById: async (id) => {
    const response = await api.get(`/sample-containers/${id}`);
    return response.data;
  },
  createSampleContainer: async (data) => {
    const response = await api.post('/sample-containers', data);
    return response.data;
  },
  updateSampleContainer: async (id, data) => {
    const response = await api.put(`/sample-containers/${id}`, data);
    return response.data;
  },
  updateSampleContainerStatus: async (id, isActive) => {
    const response = await api.patch(`/sample-containers/${id}/status`, { isActive });
    return response.data;
  },

  // 4. Investigations
  getInvestigations: async (params = {}) => {
    const response = await api.get('/investigations', { params });
    return response.data;
  },
  getInvestigationById: async (id) => {
    const response = await api.get(`/investigations/${id}`);
    return response.data;
  },
  createInvestigation: async (data) => {
    const response = await api.post('/investigations', data);
    return response.data;
  },
  updateInvestigation: async (id, data) => {
    const response = await api.put(`/investigations/${id}`, data);
    return response.data;
  },
  updateInvestigationStatus: async (id, isActive) => {
    const response = await api.patch(`/investigations/${id}/status`, { isActive });
    return response.data;
  },
  checkTestCode: async (testCode, excludeId = null) => {
    const response = await api.get('/investigations/check-code', {
      params: { testCode, excludeId },
    });
    return response.data;
  },
  updateInvestigationObservations: async (id, observations) => {
    const response = await api.put(`/investigations/${id}/observations`, observations);
    return response.data;
  },
  getInvestigationComments: async (id) => {
    const response = await api.get(`/investigations/${id}/comments`);
    return response.data;
  },
  saveInvestigationComments: async (id, comments) => {
    const response = await api.post(`/investigations/${id}/comments`, comments);
    return response.data;
  },
  getInvestigationInterpretations: async (id) => {
    const response = await api.get(`/investigations/${id}/interpretations`);
    return response.data;
  },
  saveInvestigationInterpretation: async (id, dto) => {
    const response = await api.post(`/investigations/${id}/interpretations`, dto);
    return response.data;
  },
  getInvestigationRoles: async (id) => {
    const response = await api.get(`/investigations/${id}/roles`);
    return response.data;
  },
  saveInvestigationRoles: async (id, roleIds) => {
    const response = await api.put(`/investigations/${id}/roles`, roleIds);
    return response.data;
  },
  getInvestigationConsentForms: async (id) => {
    const response = await api.get(`/investigations/${id}/consent-forms`);
    return response.data;
  },
  saveInvestigationConsentForms: async (id, forms) => {
    const response = await api.put(`/investigations/${id}/consent-forms`, forms);
    return response.data;
  },
  getObservationHelp: async (labObservationId, investigationId = null) => {
    const response = await api.get('/investigations/observation-help', {
      params: { labObservationId, investigationId },
    });
    return response.data;
  },
  saveObservationHelp: async (data) => {
    const response = await api.post('/investigations/observation-help', data);
    return response.data;
  },

  // 5. Observations
  getObservations: async (params = {}) => {
    const response = await api.get('/observations', { params });
    return response.data;
  },
  getObservationById: async (id) => {
    const response = await api.get(`/observations/${id}`);
    return response.data;
  },
  createObservation: async (data) => {
    const response = await api.post('/observations', data);
    return response.data;
  },
  updateObservation: async (id, data) => {
    const response = await api.put(`/observations/${id}`, data);
    return response.data;
  },
  updateObservationStatus: async (id, isActive) => {
    const response = await api.patch(`/observations/${id}/status`, { isActive });
    return response.data;
  },
  checkObservationCode: async (code, excludeId = null) => {
    const response = await api.get('/observations/check-code', {
      params: { code, excludeId },
    });
    return response.data;
  },
  getObservationOptions: async (search = null) => {
    const response = await api.get('/observations/options', {
      params: { search: search || undefined },
    });
    return response.data;
  },

  // 6. Referral Doctors
  getReferralDoctors: async (params = {}) => {
    const response = await api.get('/referral-doctors', { params });
    return response.data;
  },
  getReferralDoctorById: async (id) => {
    const response = await api.get(`/referral-doctors/${id}`);
    return response.data;
  },
  createReferralDoctor: async (data) => {
    const response = await api.post('/referral-doctors', data);
    return response.data;
  },
  updateReferralDoctor: async (id, data) => {
    const response = await api.put(`/referral-doctors/${id}`, data);
    return response.data;
  },
  updateReferralDoctorStatus: async (id, isActive) => {
    const response = await api.patch(`/referral-doctors/${id}/status`, { isActive });
    return response.data;
  },

  // 7. Centres
  getCentres: async (params = {}) => {
    const response = await api.get('/centres', { params });
    return response.data;
  },
  getCentreById: async (id) => {
    const response = await api.get(`/centres/${id}`);
    return response.data;
  },
  createCentre: async (data) => {
    const response = await api.post('/centres', data);
    return response.data;
  },
  updateCentre: async (id, data) => {
    const response = await api.put(`/centres/${id}`, data);
    return response.data;
  },
  updateCentreStatus: async (id, isActive) => {
    const response = await api.patch(`/centres/${id}/status`, { isActive });
    return response.data;
  },

  // 8. Panels
  getPanels: async (params = {}) => {
    const response = await api.get('/panels', { params });
    return response.data;
  },
  getPanelById: async (id) => {
    const response = await api.get(`/panels/${id}`);
    return response.data;
  },
  createPanel: async (data) => {
    const response = await api.post('/panels', data);
    return response.data;
  },
  updatePanel: async (id, data) => {
    const response = await api.put(`/panels/${id}`, data);
    return response.data;
  },
  updatePanelStatus: async (id, isActive) => {
    const response = await api.patch(`/panels/${id}/status`, { isActive });
    return response.data;
  },

  // 9. Panel Rates & Item Rates
  getPanelRates: async (panelId, params = {}) => {
    const response = await api.get(`/panels/${panelId}/rates`, { params });
    return response.data;
  },
  batchUpdatePanelRates: async (panelId, data) => {
    const response = await api.put(`/panels/${panelId}/rates`, data);
    return response.data;
  },
  getItemRates: async (itemId, params = {}) => {
    const response = await api.get(`/panels/investigations/${itemId}/rates`, { params });
    return response.data;
  },
  batchUpdateItemRates: async (itemId, data) => {
    const response = await api.put(`/panels/investigations/${itemId}/rates`, data);
    return response.data;
  },

  // 10. Centre - Panel Mappings
  getCentrePanelMappings: async (params = {}) => {
    const response = await api.get('/centre-panel-mappings', { params });
    return response.data;
  },
  createCentrePanelMapping: async (data) => {
    const response = await api.post('/centre-panel-mappings', data);
    return response.data;
  },
  bulkCreateCentrePanelMappings: async (data) => {
    const response = await api.post('/centre-panel-mappings/bulk', data);
    return response.data;
  },
  updateCentrePanelMappingStatus: async (id, isActive, toDate = null) => {
    const response = await api.patch(`/centre-panel-mappings/${id}/status`, { isActive, toDate });
    return response.data;
  },
};

export default masterService;
